import * as React from 'react'
import { connect } from 'react-redux'
import { Container } from '@amzn/dvui/dist/Container'
import { Text } from '@amzn/dvui/dist/Text'
import * as st from './faq.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { IDetailPageState } from '../../reducers'

export interface IFaqProps {
  useFaq: boolean,
  faq?: WpsRuntime.atv.wps.FaqModelProps
}

export const ConnectedFaq = ({ faq, useFaq }: IFaqProps) =>
  useFaq && faq && faq.questionList && faq.questionList.length ? (
    <Container className={`${stUtility.pageSection} ${st.faq}`} >
      <span data-automation-id="av-faq">
        <div id="faq" className={st.header}>
          <h1><Text string={faq.header} /></h1>
        </div>
        <div className={st.questions}>
          <ul>
            {faq.questionList.map((q, idx) => <li key={`faq-li-${idx}`}><Text string={q} /></li>)}
          </ul>
          <Text string={faq.seeMoreLink} />
        </div>
      </span>
    </Container>) : null

const mapStateToProps = (state: IDetailPageState): IFaqProps => ({
  useFaq: Boolean(state.features.useFaq),
  faq: state.faq[state.pageTitleId]
})

export const Faq = connect(mapStateToProps)(
  ConnectedFaq
)

